var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRtl({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 86,
    viewBox: "0 0 87 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_111494_19053",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 85,
    height: 84
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.66699,
    y: 1,
    width: 84,
    height: 84,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_111494_19053)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.66699,
    y: 1,
    width: 84,
    height: 84,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.66699,
    y: 1,
    width: 86.9647,
    height: 6,
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.64355,
    cy: 4,
    r: 1,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.64355,
    cy: 4,
    r: 1,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.6436,
    cy: 4,
    r: 1,
    fill: "#FAFAFA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.46777 11C4.46777 10.4477 4.91549 10 5.46777 10H58.8089C59.3612 10 59.8089 10.4477 59.8089 11V15C59.8089 15.5523 59.3612 16 58.8089 16H5.46777C4.91549 16 4.46777 15.5523 4.46777 15V11Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9375 7H85.6669V85H62.9375V7Z",
    fill: "#595959"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9375 11.5C64.9375 10.9477 65.3852 10.5 65.9375 10.5H73.9375C74.4898 10.5 74.9375 10.9477 74.9375 11.5V13.5C74.9375 14.0523 74.4898 14.5 73.9375 14.5H65.9375C65.3852 14.5 64.9375 14.0523 64.9375 13.5V11.5Z",
    fill: "#FAFAFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.4375 16C82.3705 16 83.9375 14.433 83.9375 12.5C83.9375 10.567 82.3705 9 80.4375 9C78.5045 9 76.9375 10.567 76.9375 12.5C76.9375 14.433 78.5045 16 80.4375 16Z",
    fill: "#FAFAFA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.667 23C83.667 22.4477 83.2193 22 82.667 22H65.9376C65.3853 22 64.9376 22.4477 64.9376 23C64.9376 23.5523 65.3853 24 65.9376 24H82.667C83.2193 24 83.667 23.5523 83.667 23Z",
    fill: "#FAFAFA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.667 28C83.667 27.4477 83.2193 27 82.667 27H65.9376C65.3853 27 64.9376 27.4477 64.9376 28C64.9376 28.5523 65.3853 29 65.9376 29H82.667C83.2193 29 83.667 28.5523 83.667 28Z",
    fill: "#FAFAFA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.667 33C83.667 32.4477 83.2193 32 82.667 32H65.9376C65.3853 32 64.9376 32.4477 64.9376 33C64.9376 33.5523 65.3853 34 65.9376 34H82.667C83.2193 34 83.667 33.5523 83.667 33Z",
    fill: "#FAFAFA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.667 38C83.667 37.4477 83.2193 37 82.667 37H65.9376C65.3853 37 64.9376 37.4477 64.9376 38C64.9376 38.5523 65.3853 39 65.9376 39H82.667C83.2193 39 83.667 38.5523 83.667 38Z",
    fill: "#FAFAFA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.667 43C83.667 42.4477 83.2193 42 82.667 42H65.9376C65.3853 42 64.9376 42.4477 64.9376 43C64.9376 43.5523 65.3853 44 65.9376 44H82.667C83.2193 44 83.667 43.5523 83.667 43Z",
    fill: "#FAFAFA"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.667 48C83.667 47.4477 83.2193 47 82.667 47H65.9376C65.3853 47 64.9376 47.4477 64.9376 48C64.9376 48.5523 65.3853 49 65.9376 49H82.667C83.2193 49 83.667 48.5523 83.667 48Z",
    fill: "#FAFAFA"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.667 53C83.667 52.4477 83.2193 52 82.667 52H65.9376C65.3853 52 64.9376 52.4477 64.9376 53C64.9376 53.5523 65.3853 54 65.9376 54H82.667C83.2193 54 83.667 53.5523 83.667 53Z",
    fill: "#FAFAFA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.667 58C83.667 57.4477 83.2193 57 82.667 57H65.9376C65.3853 57 64.9376 57.4477 64.9376 58C64.9376 58.5523 65.3853 59 65.9376 59H82.667C83.2193 59 83.667 58.5523 83.667 58Z",
    fill: "#FAFAFA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00098 79C5.00098 78.4477 5.44869 78 6.00098 78H59.001C59.5533 78 60.001 78.4477 60.001 79V81C60.001 81.5523 59.5533 82 59.001 82H6.00098C5.44869 82 5.00098 81.5523 5.00098 81V79Z",
    fill: "#BFBFBF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.16699,
    y: 0.5,
    width: 85,
    height: 85,
    rx: 2.5,
    stroke: "#BFBFBF",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRtl);
export default __webpack_public_path__ + "static/media/rtl.5aa9760844ec18c6c5299a4d8282748e.svg";
export { ForwardRef as ReactComponent };